import places3 from "../assets/images/places/webp/places3.webp";
import places2 from "../assets/images/places/webp/places2.webp";
import places1 from "../assets/images/places/webp/places1.webp";
export const scaredList = [
  {
    image: places1,
    title: "Mount Girnar",
  },
  {
    image: places2,
    title: "Rishikesh",
    customClass: "mt-4 mt-md-0",
  },
  {
    image: places3,
    title: "Ma Ganga",
    customClass: "pt-lg-0 mt-4 mt-lg-0",
  },
];

export const ModalList = [
  {
    name: "Mount Girnar",
    image: places1,
    title: "Mount Girnar",
    heading: <>Bapu spent 12 years on Mount Girnar</>,
    description:
      "Bapu spent 12 years on Mount Girnar, which is one of India's three most sacred mountains. The promise is that, if a sincere soul dwells on Girnar's slopes for a dozen years, then that soul will have the darshan (experiential presence) of his/her Beloved.",
    subDescription:
      "While few souls realize Girnar's deeper significance, Bapu knew that within Girnar is a great hall (not perceivable with physical eyes) in which the 84 Mahasiddhas and the 756 Siddhas convene to hold discussions on Yoga and the future of humanity. This 9-breasted mountain is the most inter- religious, most inter-spiritual place on the planet.",
  },
  {
    name: "Rishikesh",
    image: places2,
    title: "Rishikesh",
    heading: <>Perhaps the greatest of India's spiritual magnets</>,
    description:
      "Perhaps the greatest of India's spiritual magnets is the place of the ancient Rishis, the Seers whose spiritual mastery and service has for millennia blessed sincere seekers from all over the world. The blessings of Ma Ganga, the most spiritual of all of India's holy rivers, are available to anyone who makes a sacred bath in her waters and/or recognizes Her.",
    subDescription:
      "Divine station and inwardly contacts Her via meditation, prayer, austerity and prescribed ceremony. Blessings are communicated via a medium, which is to say that Rishikesh's blessing power is maximum in India, given that the atmosphere of Rishikesh is comparatively pure and, therefore, potent. Moreover, the DNA of spirituality, by virtue of the accumulation of resonance by Great Souls over millennia of spiritual practice, is informing this sacred place.",
  },
  {
    name: "Ma Ganga",
    image: places3,
    title: "Ma Ganga",
    heading: <>The timeless River Ganges, India's most sacred river</>,
    description:
      "The timeless River Ganges, India's most sacred river, descends from the Himalayas at its origin near Gangotri to bless on countless levels the people who live near her unique waters. Everyone wants to touch her, bathe in her, die in her. Ma Ganga has descended from Lord Shiva's hair. She carries His power. She expresses His love.",
    subDescription:
      "She beckons all to flow to the field of Conscious Infinity, the Ocean of Bliss. She also supplies forty percent of India with water. She is a profound teacher. While on superficial analysis she is polluted with every sort of thing thrown lovingly or perfunctorily into her long green body, she is ever pure. Indeed, Ganga water is known for its healing and medicinal properties. While puzzling to the world, those who understand her know that she is a Goddess who blesses and blesses.",
  },
];
